/**
 * Parcels Details
 */

// React
import React, { FC, useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";

// Context
import AuthContext from "../../authContext";

//UI
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import theme from "../../theme";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  Collapse,
  Checkbox,
  Card,
  CardContent,
  FormControlLabel,
  ClickAwayListener,
  Box,
} from "@material-ui/core";

// Icon
import Icon from "@mdi/react";
import {
  mdiAlertCircle,
  mdiArchiveOutline,
  mdiBarcode,
  mdiCheck,
  mdiChevronRight,
  mdiClose,
  mdiCounter,
  mdiKeyOutline,
  mdiPackageVariantClosed,
  mdiPrinter,
  mdiTextBoxSearch,
} from "@mdi/js";

// Components
import ListParcelItems from "./list";
import Can from "../../components/Can";
import Pagination from "@material-ui/lab/Pagination";
import Modal from "../../components/Modal";
import { useForm } from "react-hook-form";
import LabelList from "./components/labelsList";
import RenderFilter, { Filter } from "../../utils/listDaynamicFilter";

// Rules

// Helper
import {
  formaterPhoneNumber,
  removeEmptyValueObject,
  translate,
} from "../../utils/helpers";
import jMoment from "moment-jalaali";

// Type
import { Product, Props } from "./interfaces";
import clsx from "clsx";
import Client from "client-sdk/src/client";
import { UpdateInventoryItemsRequestBuilder } from "client-sdk/src/parcels/parcels";
import parcelsRepository from "client-sdk/src/Repository/parcels-repository";
import parcelItemRepository from "client-sdk/src/Repository/parcel-items-repository";
import inventoryItemsRepository from "client-sdk/src/Repository/inventory-items-repository";
import handleError from "../../utils/handleError";
import handleNotfication from "../../utils/handleNotification";
import getParcelFileReq from "client-sdk/src/parcels/file";
import { getBlockingTickets } from "../../api/ticket/get";

export type Input = {
  serial: string;
};

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& > *": {
        "@media (max-width: 768px)": {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: "16px",
      marginBottom: "16px",
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: "1px solid #ddd",
      borderRadius: "4px",
    },
    iconButton: {
      padding: 8,
      marginRight: "10px",
      position: "relative",
      "&:before": {
        content: '""',
        position: "absolute",
        width: "1px",
        height: "36px",
        top: "4px",
        left: "-9px",
        backgroundColor: "#EDF1F4",
      },
    },
    title: {
      fontWeight: 500,
    },
    filterBox: {
      position: "absolute",
      backgroundColor: "#fff",
      width: "70%",
      marginTop: "30px",
      top: "180px",
      right: "33px",
      borderRadius: "0  0 4px  4px",
      padding: "16px 16px",
      boxSizing: "border-box",
      boxShadow: "0px 2px 4px 1px rgba(0,0,0,0.1)",
      zIndex: 10,
    },
    filterOpen: {
      display: "block",
    },
    allocateIcon: {
      textAlign: "center",
      position: "relative",
      paddingTop: "10px",
      marginBottom: theme.spacing(7),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100px",
        borderRadius: "50%",
        opacity: ".5",
        backgroundColor: "#f3ab3e",
      },
    },
    item: {
      marginBottom: "24px",
      display: "flex",
      alignSelf: "center",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: "98%",
      margin: "10px auto",
    },
    label: {
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 400,
      color: "#8A8A8A",
      marginRight: "10px",
    },
    headerBox: {
      display: "flex",
      alignItems: "center",
      marginBottom: "28px",
    },
    contentlabelTitle: {
      position: "relative",
      color: theme.palette.gray.light,
      marginLeft: "40px",
      fontSize: "14px",
      fontWeight: 500,
      "&:before": {
        content: '"-"',
        position: "absolute",
        left: "-20px",
      },
    },
    loading: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "50vh",
      alignSelf: "center",
      justifyContent: "center",
      background: "#ccc",
    },
    changStatusIcon: {
      marginRight: "10px",
      position: "absolute",
    },
    changStatusBox: {
      display: "flex",
      textAlign: "left",

      fontWeight: 400,
      fontSize: "14px",
    },
    renderValue: {
      paddingLeft: "32px",
    },
    radioGroup: {
      margin: "-8px 0",
    },
    radioGroupItem: {
      borderBottom: "1px solid #D8D8D8",
      marginRight: "-8px",
      padding: "8px 16px",
      "&:last-child": {
        borderBottom: "0px",
      },
    },
    cancelTitle: {
      fontSize: "16px",
      fontWeight: 500,
      textAlign: "justify",
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    collapseIcon: {
      marginTop: "-36px",
      textAlign: "center",
      position: "relative",
      width: "100%",
      // marginBottom: theme.spacing(7),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "40px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "40px",
        borderRadius: "50%",
        backgroundColor: theme.palette.secondary.main,
        border: "5px solid white",
      },
    },
    editIcon: {
      textAlign: "center",
      position: "relative",
      marginBottom: theme.spacing(7),
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        height: "100px",
        borderRadius: "50%",
        opacity: "0.2",
        backgroundColor: theme.palette.blue.main,
      },
    },
    showCount: {
      "& .MuiSelect-icon": {
        color: "#DFA01F",
      },
    },
    card: {
      minWidth: "320px",
      display: "flex",
      background: "#fff",
      borderRadius: "4px",
      border: "1px solid #3449B0",
      boxShadow: "0px 2px 4px 1px rgba(0,0,0,0.1)",
    },
    cardItem: {
      flex: 1,
      "&:nth-child(1)": {
        flex: 0.5,
      },
      "&:nth-child(1) button": {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
      },
      "&:nth-child(2)": {
        borderRight: "1px solid #3449B0",
        borderLeft: "1px solid #3449B0",
        "& button": {
          borderRadius: 0,
        },
      },
      "&:nth-child(3) button": {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
      },
    },
    bodyContainer: {
      backgroundColor: "#fff",
      padding: "24px",
      borderRadius: "4px",
    },
    itemContainer: {
      border: "1px solid #D9D9D9",
      padding: "18px",
    },
    itemList: {
      display: "flex",
      justifyContent: "space-between",
      gap: "10px",
      margin: "24px 0",
      "& span": {
        fontSize: "16px",
      },
    },
  })
);

const inboundItems = [
  {
    name: "shrink",
    label: "شیرینک",
    info: "در این سرویس تمامی کالا های موجود در محموله با استفاده از پلاستیک حرارت دیده روکش می‌شوند.",
  },
  {
    name: "labelAttachment",
    label: "برچسب گذاری",
    info: "لیبل و یا برچسب اختصاصی که میتواند شامل قیمت، لوگو و یا دیگر اطلاعات مورد نیاز شما باشد بر روی کالاها نصب میشود.",
  },
  {
    name: "safety",
    label: "ایمن سازی",
    info: "در صورتی که کالای ارسال شده نیاز به اعمال تغییرات به صورت سطحی در ساختار دارند می‌توانید از این سرویس استفاده نمایید.",
  },
  {
    name: "repackage",
    label: "تغییر بسته‌بندی",
    info: "در این سرویس کالاهای محموله میتواند در هنگام ورود بسته‌بندی شوند و یا تغیراتی در بسته‌بندی کالاها اعمال شود.",
  },
  {
    name: "kitting",
    label: "ترکیب چند قطعه",
    info: "کیتینگ به معنی ساخت یک پکیج فروش با استفاده از چندین کالا است که میتواند به صورت مجزا ارسال شده و تحت عنوان یک کالا جای‌گذاری شود.",
  },
];

const QCItems = [
  {
    name: "productIdentification",
    label: "هویت سنجی",
    info: "با انتخاب این گزینه تمامی کالاهای موجود در محموله به صورت تک به تک مورد بررسی قرارمیگیرند",
  },
  {
    name: "checkDate",
    label: "بررسی تاریخ تولید و انقضا",
  },
  {
    name: "test",
    label: "بررسی عملکرد کالا",
  },
  {
    name: "checkContents",
    label: "بررسی محتویات کارتن",
  },
  {
    name: "requestedQc",
    label: "کنترل کیفی درخواستی",
    info: "شما می‌توانید با انتخاب این گزینه کنترل کیفی مورد نظر خود را شخصی سازی نمایید",
  },
];

const initialItems = {
  id: 0,
  parcelId: 0,
  shrink: false,
  labelAttachment: false,
  modifyPackage: false,
  repackage: false,
  kitting: false,
  productIdentification: false,
  checkDate: false,
  test: false,
  checkContents: false,
  requestedQc: false,
  inboundDescription: "",
  qcDescription: "",
};

const Details: FC<Props> = (props: Props): React.ReactElement => {
  const history = useHistory();
  const [selected, setSelected] = React.useState<string[]>([]);
  const authContext = useContext(AuthContext);
  const [ticket, setTicket] = useState(null);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [openItemsNotFound, setOpenItemsNotFound] = useState(false as boolean);
  const [openBarcode, setOpenBarcode] = useState(false as boolean);
  const [changeParcelStatusDialog, setChangeParcelStatusDialog] = useState(
    false as boolean
  );
  const [openDialogForChangeParcelStatus, setOpenDialogForChangeParcelStatus] =
    useState(false as boolean);
  const [openDialogForItemsNotRegistered, setOpenDialogForItemsNotRegistered] =
    useState(false as boolean);
  const [openRegisterItems, setOpenRegisterItems] = useState(false as boolean);
  const [openFilterBox, setOpenFilterBox] = React.useState(false);
  const [statusChanged, setStatusChanged] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);
  const [description, setDescription] = useState("");
  const [product, setProduct] = useState({} as Product);
  const { register, errors, handleSubmit, getValues, setValue, watch } =
    useForm<Input>({
      defaultValues: {
        serial: "",
      },
    });
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 400,
  } as any);
  const [filters, setFilters] = useState([] as Filter[]);
  const [printModal, setPrintModal] = useState(false as boolean);
  const classes = useStyles();
  const token = localStorage.getItem("token") || "";
  const [editMode, setEditMode] = useState(false);
  const [customizedItems, setCustomizedItems] = useState(initialItems);
  const [inventoryItemsLoading, setInventoryItemsLoading] = useState(false);
  const [parcel, setParcel] = useState({});
  const [inventoryItems, setInventoryItems] = useState([]);
  const [inventoryItemsWithSerial, setInventoryItemsWithSerial] = useState([]);
  const [inventoryItemsWithStatus, setInventoryItemsWithStatus] = useState([]);
  const [inventoryItemsCount, setInventoryItemsCount] = useState(0);

  const handleCloseDialogForItemsNotRegistered = () => {
    setOpenDialogForItemsNotRegistered(false);
  };

  const handleCloseDialogForChangeParcelStatus = () => {
    setOpenDialogForChangeParcelStatus(false);
  };

  const handleSetParcelStatusFunc = (status: string) => {
    handleSetParcelStatus(status);
  };
  const updateParcelsStatus = async (action: any) => {
    const payload = { ...action };
    try {
      const callback = await parcelsRepository.updateParcelStatus({ payload });
      handleNotfication("محموله با موفقیت به روز رسانی شد", "success");
      callback && callback();
    } catch (error) {
      handleError(error.response);
    }
  };
  const handleSetParcelStatus = (status: string) => {
    if (status === "REGISTERED") setDescription("");
    updateParcelsStatus({
      id: props.match.params.id,
      body: { status: status.replace(/'/g, '"'), description: description },
      pagination: {
        ...filtersValues,
      },
      callback: () => {
        setStatusChanged(!statusChanged);
        history.goBack();
      },
    });
    setOpenDialogForItemsNotRegistered(false);
    setOpenDialogForChangeParcelStatus(false);
  };

  const handleOpenConfirmDisable = (item: Product, link = false) => {
    if (link) {
      if (item.status !== "REGISTERED") {
        setStatusChanged(!statusChanged);
        handleSinglePrint(item)
          .then((_) => {
            const win = window.open(`${link}`, "_blank")!;
            win.focus();
          })
          .catch((err) => {});
        return;
      }
      const win = window.open(`${link}`, "_blank")!;
      win.focus();
    } else {
      setId(item.id);
      setProduct(item);
    }
  };

  const setupFilters = () => {
    setFilters([
      {
        type: "input",
        id: "productName.contains",
        label: "نام کالا",
        icon: mdiArchiveOutline,
      },
      {
        type: "input",
        id: "productCode.contains",
        label: "کد کالا",
        icon: mdiKeyOutline,
      },
      {
        type: "number",
        id: "productId.equals",
        label: "شناسه کالا",
        icon: mdiKeyOutline,
      },
      {
        type: "number",
        id: "skuId.equals",
        label: "شناسه تنوع کالا",
        icon: mdiKeyOutline,
      },
      {
        type: "input",
        id: "skuCode.contains",
        label: "کد تنوع کالا",
        icon: mdiKeyOutline,
      },
      {
        type: "input",
        id: "serialNumber.equals",
        label: "سریال کالا",
        icon: mdiKeyOutline,
      },
    ]);
  };

  const getInventoryItemsWithSerial = async (action: any) => {
    const payload = { ...action };
    try {
      const { response, callback } =
        await inventoryItemsRepository.getInventoryItemsWithSerial(
          { payload },
          payload.callback
        );
      setInventoryItemsWithSerial(response.data.content);
      if (callback) {
        callback();
      }
      if (response.data.content.length === 0)
        handleNotfication("هیچ آیتمی پیدا نشد.", "warn");
    } catch (error) {
      handleError(error.response);
    }
  };

  // const checkSerialFunc = async () => {
  //   await getInventoryItemsWithSerial({
  //     serialNumber: {equals: serial},
  //     parcelId: {equals: props.match.params.id},
  //   });
  // };
  const checkSerial = (data: any) => {
    getInventoryItemsWithSerial({
      ...filtersValues,
      serialNumber: { equals: data.serial },
      parcelId: { equals: props.match.params.id },
      callback: () => {
        setValue("serial", "");
      },
    });
  };

  const updateInventoryItemsStatus = async (action: any) => {
    const payload = { ...action };
    try {
      const callback = await inventoryItemsRepository.updateInventoryItems({
        payload,
      });
      handleNotfication("وضعیت آیتم مورد نظر با موفقیت تغییر کرد ", "success");
      callback && callback();
    } catch (error) {
      handleError(error.response);
    }
  };

  const handleAllocateUserFunc = () => {
    const inventoryItem = product.id ? product : inventoryItemsWithSerial[0];
    updateInventoryItemsStatus({
      id: id !== -1 ? id : inventoryItemsWithSerial[0]?.id,
      body:
        inventoryItem.status !== "REGISTERED" ? '"REGISTERED"' : '"UNLOADED"',
      ...filtersValues,
      callback: () => {
        setStatusChanged(!statusChanged);
      },
    });
    setOpenRegisterItems(false);
  };
  const getInventoryItemWithStatus = async (action: any) => {
    const payload = { ...action };
    try {
      const response =
        await inventoryItemsRepository.getInventoryItemsWithStatus({ payload });
      setInventoryItemsWithStatus(response.data.content);
    } catch (error) {
      handleError(error.response);
    }
  };

  const getInventoryItemsWithStatus = async () => {
    await getInventoryItemWithStatus({
      parcelId: { equals: props.match.params.id },
      status: { notIn: "REGISTERED" },
      ...filtersValues,
    });
    setChangeParcelStatusDialog(true);
  };

  const handleChangeParcelStatus = () => {
    if (inventoryItemsWithStatus.length !== 0) {
      setOpenDialogForItemsNotRegistered(true);
    } else {
      setOpenDialogForChangeParcelStatus(true);
    }
  };

  const handleChangeSizePage = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  // const handleSerial = (value: string) => {
  //   setSerial(value);
  // };

  // useEffect(() => {
  //   if (serial.length === 10) {
  //     setTimeout(() => {
  //       checkSerialFunc().then();
  //     }, 500);
  //   }
  // }, [serial]);
  const getParcelWithId = async (id: any) => {
    const payload = { id };
    try {
      const response = await parcelsRepository.getParcelsWithId({ payload });
      setCustomizedItems(
        response.data.parcelCustomizedOperationDTO || initialItems
      );
      setParcel(response.data);
    } catch (error) {
      handleError(error.response);
    }
  };
  const getParcelInventoryItems = async (action: any) => {
    const payload = { ...action };
    try {
      setInventoryItemsLoading(true);
      const { response, callback } =
        await inventoryItemsRepository.getParcelInventoryItems({ payload });
      setInventoryItems(response.data.content);
      setInventoryItemsCount(response.data.totalElements);
      if (callback) {
        callback();
      }
    } catch (error) {
      handleError(error.response);
    } finally {
      setInventoryItemsLoading(false);
    }
  };
  useEffect(() => {
    const { page, size } = filtersValues;
    const { id } = props.match.params;
    getParcelWithId(id);
    getParcelInventoryItems({
      ...filtersValues,
      parcelId: { equals: id },
      page,
      size,
      sort: "sku.product.name,id,asc",
    });
    setupFilters();
  }, [statusChanged, filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    handleCloseBarcode(true);
  }, [inventoryItemsWithSerial]);

  useEffect(() => {
    if (changeParcelStatusDialog) handleChangeParcelStatus();
  }, [inventoryItemsWithStatus]);

  useEffect(() => {
    if (product.id) {
      handleAllocateUserFunc();
    }
  }, [product]);

  useEffect(() => {
    getTicket();
  }, []);
  const getTicket = async () => {
    const { id } = props.match.params;
    try {
      const res = await getBlockingTickets({
        "serviceId.in": "1",
        linkType: "parcel",
        linkId: id,
        "status.notIn": "CLOSED",
      });
      setTicket(res.data[0]);
      res.data.length > 0 &&
        handleNotfication("محموله دارای تیکت است.", "warn");
    } catch (error) {
      handleError(error);
    }
  };

  const handleClose = () => {
    setOpenRegisterItems(false);
  };

  const handleCloseItemsNotFound = () => {
    setOpenItemsNotFound(false);
  };

  const handleCloseBarcode = (setRegistered: boolean) => {
    // setOpenBarcode(false);
    setValue("serial", "");
    if (setRegistered && inventoryItemsWithSerial.length !== 0) {
      setId(-1);
      setProduct({} as Product);
      // setOpenRegisterItems(true);
      handleAllocateUserFunc();
    }
  };

  const handleClosePrintModal = () => {
    setFiltersValues({
      page: 0,
      size: 400,
    });
    setPrintModal(false);
  };

  const handleOpenPrintModal = () => {
    setPrintModal(true);
  };

  const handleClick = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleSinglePrint = async (item: Product) => {
    try {
      return await updateInventoryItemsStatus({
        id: item.id,
        body: '"REGISTERED"',
        ...filtersValues,
      });
    } catch (error) {
      throw error;
    }
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = inventoryItems
        .filter((el: any) => el.status !== "REGISTERED")
        .map((n: any) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };
  const registerInventoryItems = async () => {
    const { page, size } = filtersValues;
    const { id } = props.match.params;
    try {
      await parcelItemRepository.registerAllParcelItemsUnit({
        payload: { id: parcel.id },
      });
      handleNotfication("وضعیت آیتم ها بروزرسانی شد.", "success");
      getParcelWithId(id);
      getParcelInventoryItems({
        ...filtersValues,
        parcelId: { equals: id },
        page,
        size,
        sort: "sku.product.name,id,asc",
      });
    } catch (error) {
      handleError(error?.response);
    }
  };
  const registerAllInventoryItems = async (ids: number[]) => {
    try {
      const request = new UpdateInventoryItemsRequestBuilder()
        .data({
          ids: ids,
        })
        .build();
      const client = new Client(token);
      await client.execute(request);
    } catch (err) {
      //err
    }
  };
  const handleClickPrint = () => {
    registerAllInventoryItems(selected);
    window.open(
      `/print-labels/${props.match.params.id}?items=${selected.join(",")}`
    );
  };

  const handleFilterStatus = (status: string) => {
    if (filtersValues?.["status.equals"] === status) {
      setFiltersValues((prevState: any) => ({
        ...prevState,
        "status.equals": undefined,
      }));
      return;
    }
    setFiltersValues((prevState: any) => ({
      ...prevState,
      "status.equals": status,
    }));
  };

  const handleCustomizedItemChange = (event) => {
    const newItems = { ...customizedItems };
    newItems[event.target.name] = event.target.checked;
    setCustomizedItems(newItems);
    // const index = packageChoice.indexOf(event.target.name)
    // if (index > -1) {
    //   const newChoises = [...packageChoice]
    //   newChoises.splice(index, 1)
    //   setPackageChoice(newChoises)
    // } else {
    //   setPackageChoice([...packageChoice, event.target.name]);
    // }
  };

  const getNotRegisteredParcelItems = () => {
    if (parcel.items) {
      return parcel.items.filter((item: any) => item.status !== "REGISTERED");
    }
    return [];
  };

  const updateCustomizedItems = async () => {
    try {
      const { response } = await parcelsRepository.updateParcels({
        payload: {
          body: { ...parcel, parcelCustomizedOperationDTO: customizedItems },
        },
      });
      setParcel(response.data);
      setCustomizedItems(
        response.data.parcelCustomizedOperationDTO || initialItems
      );
      setEditMode(false);
      handleNotfication("محموله با موفقیت تغییر کرد", "success");
    } catch (error: any) {
      handleError(error);
    }
  };

  const editModeToggle = () => {
    if (editMode) {
      updateCustomizedItems();
    } else {
      setEditMode(true);
    }
  };

  const handleClickAway = (e: any) => {
    // TODO: Shet
    if (
      e.target.getAttribute("dir") !== "rtl" &&
      e.target.getAttribute("type") !== "checkbox" &&
      e.target.getAttribute("class") !== "PrivateSwitchBase-input-73" &&
      e.target.getAttribute("class") !==
        "MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock" &&
      e.target.getAttribute("aria-hidden") !== "true"
    )
      setOpenFilterBox(false);
  };

  const handleClickFilter = () => {
    setOpenFilterBox((prev) => !prev);
  };

  const downloadDigiFile = async () => {
    try {
      const response = await getParcelFileReq(parcel.id);
      const file = URL.createObjectURL(response.blob);
      const link = document.createElement("a");
      link.href = file;
      link.setAttribute("download", parcel?.labelFileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.headerBox}>
        <Button
          aria-label="details"
          size="small"
          onClick={() => window.history.back()}>
          <Icon path={mdiChevronRight} size={1} className={classes.icon} />
        </Button>
        <Typography variant="h6" component="h2">
          {`
        جزيیات محموله 
        ${parcel.destinationName}
        `}
        </Typography>
        {/* <span className={classes.contentlabelTitle}>{parcel.id}</span> */}
      </div>
      <div className={classes.bodyContainer}>
        <Grid container lg={12}>
          <Grid lg={2}>
            <Typography
              variant="h6"
              component="h2"
              style={{
                position: "sticky",
                top: "24px",
                marginBottom: "24px",
                fontWeight: "bold",
              }}>
              اطلاعات محموله - {parcel.id}
            </Typography>
            <Card style={{ position: "sticky", top: "80px" }}>
              <CardContent>
                {/* <div className={classes.item}>
                  <span className={classes.label}>{'وضعیت تحویل:  '}</span>
                  <span style={{ flex: 1 }}>
                    {translate(parcel.status, 'parcel')}
                  </span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{'انبار مقصد:  '}</span>

                  <span style={{ flex: 1 }}>{parcel.destinationName}</span>
                </div> */}
                <div className={classes.item}>
                  <span className={classes.label}>{" نوع اینباند:  "}</span>

                  <span style={{ flex: 1 }}>
                    {translate(parcel?.inboundType, "parcel")}
                  </span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{" تنوع کالا:  "}</span>

                  <span style={{ flex: 1 }}>{parcel?.items?.length}</span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{"تعداد آیتم ها:  "}</span>

                  <span style={{ flex: 1 }}>{inventoryItemsCount}</span>
                </div>
                {/* <div className={classes.item}>
                  <span className={classes.label}>{'نوع ارسال:  '}</span>
                  <span style={{ flex: 1 }}>{translate(parcel.deliveryType)}</span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{'شناسه:  '}</span>

                  <span style={{ flex: 1 }}>{parcel.id}</span>
                </div> */}
                <Divider style={{ width: "100%", marginBottom: "24px" }} />
                {/* <div className={classes.item}>
                  <span className={classes.label}>{'تاریخ ثبت:  '}</span>
                  <span style={{ flex: 1 }}>
                    {parcel.deliveryDate &&
                      `${jMoment(parcel.shippingDate, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}`}
                  </span>
                </div> */}
                <div className={classes.item}>
                  <span className={classes.label}>{"تاریخ تحویل:  "}</span>
                  <span style={{ flex: 1 }}>
                    {parcel.shippingDate &&
                      `${jMoment(parcel.deliveryDate, "YYYY/MM/DD")
                        .locale("fa")
                        .format("jYYYY/jMM/jDD")}`}
                  </span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{"بازه تحویل:  "}</span>
                  <span style={{ flex: 1 }}>
                    {parcel.deliveryStartTime &&
                      jMoment(parcel.deliveryStartTime, "hh:mm")
                        .locale("fa")
                        .format("HH:mm")}
                    {" - "}
                    {parcel.deliveryEndTime &&
                      jMoment(parcel.deliveryEndTime, "hh:mm")
                        .locale("fa")
                        .format("HH:mm")}
                  </span>
                </div>
                <Divider style={{ width: "100%", marginBottom: "24px" }} />
                <div className={classes.item}>
                  <span className={classes.label}>{"ارسال کننده:  "}</span>
                  <span style={{ flex: 1 }}>
                    {parcel.partnerName ?? parcel.sellerName}
                  </span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{"نام مسئول حمل:  "}</span>

                  <span style={{ flex: 1 }}>{parcel.agentName}</span>
                </div>
                <div className={classes.item}>
                  <span className={classes.label}>{"شماره همراه:  "}</span>
                  <span style={{ flex: 1 }}>
                    {formaterPhoneNumber(parcel.agentPhoneNumber)}
                  </span>
                </div>
                <Divider style={{ width: "100%", marginBottom: "24px" }} />
                {/* <div className={classes.item}>
                  <span className={classes.label}>{'آدرس انبار :  '}</span>
                  <span style={{ flex: 1 }}>{parcel.destinationAddress}</span>
                </div> */}
                <div className={classes.item}>
                  <span className={classes.label}>{"توضیحات :  "}</span>
                  <span style={{ flex: 1 }}>{parcel?.description}</span>
                </div>
                {parcel?.labelFileName && (
                  <div className={classes.item}>
                    <span className={classes.label}>
                      {"فایل دیجی‌کالا :  "}
                    </span>
                    <span
                      style={{ flex: 1 }}
                      className="link"
                      onClick={downloadDigiFile}>
                      {parcel?.labelFileName}
                    </span>
                  </div>
                )}
              </CardContent>
            </Card>
          </Grid>
          <Grid lg={10}>
            <Typography
              variant="h6"
              component="h2"
              style={{
                marginRight: "24px",
                marginBottom: "24px",
                fontWeight: "bold",
              }}>
              خدمات مازاد
            </Typography>
            <Card
              style={{
                paddingTop: "0",
                marginRight: "24px",
                marginBottom: "24px",
              }}>
              <CardContent>
                <div className={classes.itemContainer}>
                  <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                    اینباند
                  </span>
                  <div className={classes.itemList}>
                    {inboundItems.map((item) => (
                      <>
                        {editMode ? (
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={handleCustomizedItemChange}
                                checked={customizedItems[item.name]}
                                name={item.name}
                                color="primary"
                                // disabled={values.inboundType == "VIP"}
                                size="small"
                              />
                            }
                            label={
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  columnGap: "10px",
                                }}>
                                <Typography
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "400",
                                    color: "rgba(47, 72, 88, 1)",
                                  }}>
                                  {item.label}
                                </Typography>
                              </div>
                            }
                          />
                        ) : (
                          <span
                            style={{
                              color: customizedItems[item.name]
                                ? "#313131"
                                : "#D3D7E8",
                              lineHeight: "38px",
                            }}>
                            {item.label}
                          </span>
                        )}
                      </>
                    ))}
                  </div>
                  {customizedItems?.inboundDescription && (
                    <>
                      <Divider style={{ width: "100%" }} />
                      <p style={{ marginBottom: "0" }}>
                        {customizedItems?.inboundDescription}
                      </p>
                    </>
                  )}
                </div>
                <div
                  className={classes.itemContainer}
                  style={{ marginTop: "24px" }}>
                  <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                    کنترل کیفی
                  </span>
                  <div className={classes.itemList}>
                    {QCItems.map((item) => (
                      <>
                        {editMode ? (
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={handleCustomizedItemChange}
                                checked={customizedItems[item.name]}
                                name={item.name}
                                color="primary"
                                // disabled={values.inboundType == "VIP"}
                                size="small"
                              />
                            }
                            label={
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  columnGap: "10px",
                                }}>
                                <Typography
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "400",
                                    color: "rgba(47, 72, 88, 1)",
                                  }}>
                                  {item.label}
                                </Typography>
                              </div>
                            }
                          />
                        ) : (
                          <span
                            style={{
                              color: customizedItems[item.name]
                                ? "#313131"
                                : "#D3D7E8",
                              lineHeight: "38px",
                            }}>
                            {item.label}
                          </span>
                        )}
                      </>
                    ))}
                  </div>
                  {customizedItems?.qcDescription && (
                    <>
                      <Divider style={{ width: "100%" }} />
                      <p style={{ marginBottom: "0" }}>
                        {customizedItems?.qcDescription}
                      </p>
                    </>
                  )}
                </div>
                {authContext?.role == "WAREHOUSE_ADMIN" && (
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ marginTop: "24px", padding: "6px 16px" }}
                      onClick={editModeToggle}>
                      {editMode ? "تایید" : "ویرایش"}
                    </Button>
                  </div>
                )}
              </CardContent>
            </Card>
            <Typography
              variant="h6"
              component="h2"
              style={{
                marginRight: "24px",
                marginBottom: "24px",
                fontWeight: "bold",
              }}>
              جزئیات محموله
            </Typography>
            <Grid
              style={{
                marginTop: "30px",
                marginBottom: "20px",
                paddingRight: "24px",
              }}
              container
              alignItems="center"
              justify="space-between">
              <div className={classes.card}>
                <div className={classes.cardItem}>
                  <Button
                    fullWidth
                    color="primary"
                    size="medium"
                    variant={
                      !["REGISTERED", "UNLOADED"].includes(
                        filtersValues?.["status.equals"]
                      )
                        ? "contained"
                        : undefined
                    }
                    onClick={() => {
                      setFiltersValues((prevState: any) => ({
                        ...prevState,
                        "status.equals": undefined,
                      }));
                    }}>
                    همه
                  </Button>
                </div>
                <div className={classes.cardItem}>
                  <Button
                    fullWidth
                    color="primary"
                    size="medium"
                    variant={
                      filtersValues?.["status.equals"] === "REGISTERED"
                        ? "contained"
                        : undefined
                    }
                    onClick={() => {
                      handleFilterStatus("REGISTERED");
                    }}>
                    رجیستر شده
                  </Button>
                </div>
                <div className={classes.cardItem}>
                  <Button
                    fullWidth
                    color="primary"
                    size="medium"
                    variant={
                      filtersValues?.["status.equals"] === "UNLOADED"
                        ? "contained"
                        : undefined
                    }
                    onClick={() => {
                      handleFilterStatus("UNLOADED");
                    }}>
                    رجیستر نشده
                  </Button>
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                {/* <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                  <Checkbox
                    checked={!!parcel?.hasVipQc}
                    onClick={handleQCVIPCheckbox}
                  />
                  <span>کنترل کیفیت ویژه</span>
                </Grid> */}
                {ticket && (
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    style={{ marginRight: "20px" }}
                    onClick={() => {
                      history.push(`/ticketing/${ticket?.id}`);
                    }}>
                    سابقه تیکت
                  </Button>
                )}
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  style={{ marginLeft: "20px", marginRight: "20px" }}
                  endIcon={<Icon path={mdiCheck} size={1} />}
                  onClick={() => {
                    history.push(
                      `/parcel/${props.match.params.id}/inventory-items/submit`
                    );
                  }}>
                  {"تایید مشخصات کالا"}
                </Button>
                <Can
                  perform="/print-labels/:id"
                  role={authContext.user.role}
                  yes={() => (
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      style={{ marginLeft: "20px" }}
                      endIcon={<Icon path={mdiPrinter} size={1} />}
                      onClick={handleOpenPrintModal}>
                      {"چاپ سریال"}
                    </Button>
                  )}
                />
                <Link
                  to={`/parcels/receipts/${parcel.id}`}
                  target="_blank"
                  style={{ textDecoration: "none" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    endIcon={<Icon path={mdiPrinter} size={1} />}>
                    {"چاپ رسید"}
                  </Button>
                </Link>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  style={{ marginRight: "20px" }}
                  endIcon={<Icon path={mdiBarcode} size={1} />}
                  onClick={() => {
                    setOpenBarcode(true);
                  }}>
                  {"چک کردن بارکد"}
                </Button>
              </div>
            </Grid>
            <Card
              style={{
                paddingTop: "0",
                marginRight: "24px",
                marginTop: "24px",
                marginBottom: "24px",
              }}>
              {inventoryItemsLoading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                inventoryItems && (
                  <ListParcelItems
                    parcelId={props.match.params.id}
                    operatorId={parcel.operatorId}
                    handleOpenConfirmDisable={handleOpenConfirmDisable}
                    data={inventoryItems}
                    selectAll={registerInventoryItems}
                    checkedAll={getNotRegisteredParcelItems().length == 0}
                  />
                )
              )}
              <Box mt={2} />
              {inventoryItems.length > 0 && (
                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <FormControl
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}>
                      <div style={{ marginLeft: "10px", color: "#8a8a8a" }}>
                        {" "}
                        تعداد نمایش در هر صفحه:
                      </div>
                      <Select
                        open={openSize}
                        onClose={handleClose}
                        onOpen={() => setOpenSize(true)}
                        value={filtersValues.size}
                        onChange={handleChangeSizePage}>
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid xs={12} sm={6} container item direction="row-reverse">
                    <Pagination
                      count={Math.ceil(
                        inventoryItemsCount / filtersValues.size
                      )}
                      color="secondary"
                      page={filtersValues.page + 1}
                      onChange={handleChangePage}
                    />
                  </Grid>
                </Grid>
              )}
            </Card>
            <Grid
              xs={12}
              style={{ marginTop: "30px" }}
              container
              justify="flex-end">
              <Button
                aria-label="register-parcel"
                onClick={getInventoryItemsWithStatus}
                disabled={!!ticket}
                variant="contained"
                color="primary">
                <span className="">{"تایید تطابق محموله"}</span>
                {/* <Icon path={mdiChevronLeft} size={1} /> */}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </div>

      <Dialog
        fullWidth
        open={openRegisterItems}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle>
          <div
            style={{
              position: "absolute",
              left: "17px",
              zIndex: 10,
            }}>
            {handleClose ? (
              <IconButton aria-label="close" onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.allocateIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
          </div>
          <div>
            {id !== -1 || inventoryItemsWithSerial.length === 0 ? (
              <div>
                {` از
            تغییر وضعیت کالا با شناسه
            "${id}"
            به
            "${product.status === "REGISTERED" ? "تطبیق نشده" : "تطبیق شده"}"
          مطمئن هستید؟`}
              </div>
            ) : (
              <div>
                <Grid
                  style={{ marginBottom: "15px" }}
                  container
                  alignItems="center">
                  <Grid item xs={12} sm={4}>
                    <div className={classes.item}>
                      <span className={classes.label}>
                        <Icon
                          path={mdiArchiveOutline}
                          size={1}
                          className={classes.icon}
                        />
                        {"نام کالا :  "}
                      </span>
                      <span>{inventoryItemsWithSerial[0]?.productName}</span>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <div className={classes.item}>
                      <span className={classes.label}>
                        <Icon
                          path={mdiKeyOutline}
                          size={1}
                          className={classes.icon}
                        />
                        {"شناسه کالا :  "}
                      </span>
                      <span>{inventoryItemsWithSerial[0]?.productId}</span>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <div className={classes.item}>
                      <span className={classes.label}>
                        <Icon
                          path={mdiCounter}
                          size={1}
                          className={classes.icon}
                        />
                        {"تعداد :  "}
                      </span>
                      <span>{inventoryItemsWithSerial[0]?.amount}</span>
                    </div>
                  </Grid>
                </Grid>
                <div className={classes.cancelTitle}>
                  {` از
            تغییر وضعیت کالا با مشخصات بالا
            به تطبیق شده
          مطمئن هستید؟`}
                </div>
              </div>
            )}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large">
                {"خیر"}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                onClick={handleAllocateUserFunc}
                fullWidth
                variant="contained"
                size="large">
                {"بله"}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openDialogForChangeParcelStatus}
        onClose={handleCloseDialogForChangeParcelStatus}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle>
          <div
            style={{
              position: "absolute",
              left: "17px",
              zIndex: 10,
            }}>
            {handleCloseDialogForChangeParcelStatus ? (
              <IconButton
                aria-label="close"
                onClick={handleCloseDialogForChangeParcelStatus}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
          </div>
          <div className={classes.cancelTitle}>
            {` از 
            تغییر وضعیت محموله به تطبیق شده
          مطمئن هستید؟`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseDialogForChangeParcelStatus}
                variant="contained"
                color="secondary"
                size="large">
                {"خیر"}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                onClick={(e) => handleSetParcelStatusFunc("REGISTERED")}
                fullWidth
                variant="contained"
                size="large">
                {"بله"}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openDialogForItemsNotRegistered}
        onClose={handleCloseDialogForItemsNotRegistered}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle>
          <div
            style={{
              position: "absolute",
              left: "17px",
              zIndex: 10,
            }}>
            {handleCloseDialogForItemsNotRegistered ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDialogForItemsNotRegistered}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.allocateIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
          </div>
          <div className={classes.cancelTitle}>
            {inventoryItemsWithStatus.length > 1 ? (
              <div>
                {`تعداد 
                "${inventoryItemsWithStatus.length}"
                آیتم از کالاها
                مانند آیتم با مشخصات 
              "${"نام کالا"} : ${
                  inventoryItemsWithStatus[0]?.productName
                }  - ${"شناسه کالا"} : ${
                  inventoryItemsWithStatus[0]?.productId
                }"
              هنوز تطبیق داده نشده است.`}
              </div>
            ) : (
              <div>
                {`آیتم با شناسه 
                "${inventoryItemsWithStatus[0]?.id}"
                هنوز تطبیق داده نشده است.`}
              </div>
            )}
            <div>
              <Grid>
                <TextField
                  fullWidth
                  id="description"
                  name="description"
                  autoFocus
                  rows={3}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  label="توضیحات"
                />
              </Grid>
            </div>
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseDialogForItemsNotRegistered}
                variant="contained"
                color="secondary"
                size="large">
                {"بررسی مجدد"}
              </Button>
            </Grid>

            <Grid item xs={4}>
              <Button
                onClick={(e) => handleSetParcelStatusFunc("CONFLICTED")}
                fullWidth
                variant="contained"
                size="large">
                {"ایجاد مغایرت"}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openItemsNotFound}
        onClose={handleCloseItemsNotFound}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle>
          <div
            style={{
              position: "absolute",
              left: "17px",
              zIndex: 10,
            }}>
            {handleCloseItemsNotFound ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseItemsNotFound}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.allocateIcon}>
            <Icon path={mdiAlertCircle} size={4} color="#faa320" />
          </div>
          <div className={classes.cancelTitle}>
            {`آیتم مورد نظر با سریال 
            " ${getValues().serial} "
            یافت نشد.`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container justify="flex-end">
            <Button
              autoFocus
              onClick={handleCloseItemsNotFound}
              variant="contained"
              color="secondary"
              size="large">
              {"باشه"}
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
      <Modal
        maxWidth="lg"
        onClose={() => setOpenBarcode(false)}
        open={openBarcode}
        title={
          <div>
            <Icon
              path={mdiPackageVariantClosed}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <form onSubmit={handleSubmit(checkSerial)}>
            <Grid container>
              <Grid xs={12}>
                <div
                  style={{
                    width: "100%",
                    marginBottom: "30px",
                  }}>
                  <TextField
                    fullWidth
                    autoFocus
                    id="serial"
                    name="serial"
                    label="سریال"
                    inputRef={register({ required: true })}
                    error={errors.serial && true}
                  />
                </div>
              </Grid>
              <Grid xs={12} container justify="flex-end">
                <Button
                  variant="contained"
                  color="secondary"
                  type="submit"
                  size="large"
                  startIcon={<Icon path={mdiTextBoxSearch} size={1} />}
                  disabled={watch("serial")?.length === 0}>
                  {"یافتن کالا"}
                </Button>
              </Grid>
            </Grid>
          </form>
        }
      />

      <Modal
        maxWidth="xl"
        onClose={handleClosePrintModal}
        open={printModal}
        title={
          <div style={{ textAlign: "center" }}>
            <Icon path={mdiPrinter} size={2} color={theme.palette.green.main} />
          </div>
        }
        content={
          <Grid container>
            <Grid item md={6}>
              <span>تعداد کل: {inventoryItemsCount}</span>
              <br />
              <span>
                تعداد در صفحه:{" "}
                {
                  inventoryItems?.filter((el) => el.status !== "REGISTERED")
                    .length
                }
              </span>
            </Grid>
            <Grid
              container
              justify="flex-end"
              item
              xs={12}
              md={6}
              style={{ marginBottom: "5px" }}>
              <ClickAwayListener onClickAway={handleClickAway}>
                <div>
                  <Button
                    type="button"
                    onClick={handleClickFilter}
                    className={classes.iconButton}
                    aria-label="search">
                    {openFilterBox ? "بستن" : "جستجوی پیشرفته"}
                  </Button>
                  {openFilterBox ? (
                    <div
                      className={clsx(classes.filterBox, {
                        [classes.filterOpen]: openFilterBox,
                      })}>
                      <RenderFilter
                        filters={filters}
                        onFilter={(filtervalues: any) => {
                          setFiltersValues({
                            ...removeEmptyValueObject(filtervalues),
                            parcelId: { equals: props.match.params.id },
                            page: 0,
                            size: 100,
                          });
                          setOpenFilterBox(false);
                        }}
                        setOpenFilterBox={setOpenFilterBox}
                      />
                    </div>
                  ) : null}
                </div>
              </ClickAwayListener>
            </Grid>
            <Grid xs={12} style={{ marginBottom: "20px", marginTop: "10px" }}>
              <LabelList
                selected={selected}
                handleSelectAllClick={handleSelectAllClick}
                handleClick={handleClick}
                data={inventoryItems?.filter(
                  (el) => el.status !== "REGISTERED"
                )}
              />
            </Grid>
            <Grid xs={12} container justify="space-between">
              <Pagination
                count={Math.ceil(inventoryItemsCount / filtersValues.size)}
                color="secondary"
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
              <Button
                disabled={selected.length < 1}
                variant="contained"
                color="secondary"
                size="large"
                onClick={handleClickPrint}
                startIcon={<Icon path={mdiPrinter} size={1} />}>
                {"پرینت سریال‌ها"}
              </Button>
            </Grid>
          </Grid>
        }
      />
    </div>
  );
};

export default Details;
